// extracted by mini-css-extract-plugin
export var compactFilters = "_ed-4";
export var detailImage = "_ed-1";
export var dropdownContainer = "_ed-2";
export var imageContainer = "_ed-0";
export var selectedCard = "_ed-3";